// Mock data untuk Seleno Company Profile Website

export const companyInfo = {
  name: "Seleno",
  fullName: "PT Segara Lentera Teknologi",
  tagline: "Integrating Technology, Maximizing Value",
  established: "2020",
  description: "Seleno menghadirkan solusi IT terpadu dan keamanan siber mutakhir untuk membangun ekosistem bisnis yang tangguh.",
  phone: ["021-5020 7737"],
  email: ["sales.ar@seleno.id"],
  address: "18 Office Park, 21st Floor, Unit 21H, Kebagusan, Pasar Minggu, Jakarta Selatan 12520",
  website: "seleno.id"
};

export const services = [
  {
    id: 1,
    slug: "infrastructure-data-center-cloud",
    icon: "Server",
    title: "Infrastructure, Data Center & Cloud",
    description: "Solusi lengkap untuk transformasi infrastruktur IT modern",
    descriptionEn: "Complete solutions for modern IT infrastructure transformation",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=900&q=80",
    features: [
      "Desain & Konstruksi Data Center dengan arsitektur fisik optimal",
      "Modernisasi Infrastruktur IT (Server Consolidation, Virtualization)",
      "Solusi Hybrid & Multi-Cloud untuk fleksibilitas maksimal",
      "Optimasi efisiensi energi dan keamanan fisik 24/7"
    ],
    featuresEn: [
      "Data Center Design & Construction with optimal physical architecture",
      "IT Infrastructure Modernization (Server Consolidation, Virtualization)",
      "Hybrid & Multi-Cloud Solutions for maximum flexibility",
      "Energy efficiency optimization and 24/7 physical security"
    ]
  },
  {
    id: 2,
    slug: "cyber-security-solution",
    icon: "Shield",
    title: "Cyber Security Solution",
    description: "Perlindungan berlapis untuk jaringan, data, dan sistem Anda",
    descriptionEn: "Multi-layered protection for your networks, data, and systems",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=900&q=80",
    features: [
      "Keamanan Jaringan & Monitoring 24/7 dengan SOC dan SIEM",
      "Perlindungan Endpoint & Data (EDR, DLP, Encryption, MFA)",
      "Manajemen Insiden & Pemulihan (Incident Response, Ransomware Protection)",
      "Layanan Keamanan Terkelola (Security Assessment, Compliance)"
    ],
    featuresEn: [
      "Network Security & 24/7 Monitoring with SOC and SIEM",
      "Endpoint & Data Protection (EDR, DLP, Encryption, MFA)",
      "Incident Management & Recovery (Incident Response, Ransomware Protection)",
      "Managed Security Services (Security Assessment, Compliance)"
    ]
  },
  {
    id: 3,
    slug: "geospatial-technology",
    icon: "MapPin",
    title: "GeoSpatial Technology",
    description: "Analisis spasial untuk perencanaan strategis dan kebijakan tepat sasaran",
    descriptionEn: "Specialized analysis for strategic planning and targeted policy-making",
    image: "https://images.unsplash.com/photo-1736117703416-f260ee174bac?auto=format&fit=crop&w=900&q=80",
    features: [
      "Optimalisasi PAD melalui Sinkronisasi NIB-NOP",
      "Analisis Perubahan Lahan untuk Perencanaan Strategis",
      "Analisis Kependudukan untuk Kebijakan Sosial",
      "Identifikasi area rawan bencana dan perencanaan kota berkelanjutan"
    ],
    featuresEn: [
      "PAD Optimization through NIB-NOP Synchronization",
      "Land Use Change Analysis for Strategic Planning",
      "Demographic Analysis for Social Policy",
      "Disaster-Prone Area Identification and Sustainable Urban Planning"
    ]
  },
  {
    id: 4,
    slug: "database-management",
    icon: "Database",
    title: "Database Management",
    description: "Solusi database komprehensif untuk performa dan produktivitas optimal",
    descriptionEn: "Comprehensive database solutions for optimal performance and productivity",
    image: "https://images.unsplash.com/photo-1642775196125-38a9eb496568?auto=format&fit=crop&w=900&q=80",
    features: [
      "Migrasi Database seamless tanpa downtime",
      "Optimasi performa dan produktivitas database",
      "Arsitektur Hybrid/Multi-Cloud untuk fleksibilitas",
      "Alat manajemen cerdas dengan rekomendasi berbasis AI"
    ],
    featuresEn: [
      "Seamless database migration without downtime",
      "Database performance and productivity optimization",
      "Hybrid/Multi-Cloud architecture for flexibility",
      "Intelligent management tools with AI-based recommendations"
    ]
  }
];

export const partners = [
  { name: "Palo Alto Networks", logo: "paloalto" },
  { name: "Fortinet", logo: "fortinet" },
  { name: "Juniper Networks", logo: "juniper" },
  { name: "Sophos", logo: "sophos" },
  { name: "Dell Technologies", logo: "dell" },
  { name: "Cisco", logo: "cisco" },
  { name: "VMware", logo: "vmware" },
  { name: "Microsoft", logo: "microsoft" },
  { name: "HPE", logo: "hpe" },
  { name: "Nutanix", logo: "nutanix" },
  { name: "Veeam", logo: "veeam" },
  { name: "Veritas", logo: "veritas" }
];

export const clients = [
  { name: "Kementerian ESDM", type: "government", category: "central" },
  { name: "BSSN", type: "government", category: "central" },
  { name: "KPU (Komisi Pemilihan Umum)", type: "government", category: "central" },
  { name: "Perpustakaan Nasional RI", type: "government", category: "central" },
  { name: "KPK", type: "government", category: "central" },
  { name: "PERURI", type: "government", category: "central" },
  { name: "BSrE", type: "government", category: "central" },
  { name: "Kementerian PUPR", type: "government", category: "central" },
  { name: "Badan Otorita Borobudur", type: "government", category: "central" },
  { name: "Perhutani", type: "government", category: "central" },
  { name: "PT Bukit Asam", type: "government", category: "central" },
  { name: "Hutama Karya (HK)", type: "government", category: "central" },
  { name: "Mitratel", type: "government", category: "central" },
  { name: "Infomedia", type: "government", category: "central" },

  { name: "Bapenda Jakarta", type: "government", category: "local" },
  { name: "Pemkab Kutai Kartanegara", type: "government", category: "local" },
  { name: "Pemkab Jembrana", type: "government", category: "local" },
  { name: "Pemkab Buleleng", type: "government", category: "local" },
  { name: "Pemkab Badung", type: "government", category: "local" },
  { name: "Pemkab Tabanan", type: "government", category: "local" },
  { name: "Pemkab Karangasem", type: "government", category: "local" },
  { name: "Pemkab Klungkung", type: "government", category: "local" },
  { name: "Pemkab Bekasi", type: "government", category: "local" },

  { name: "Toyota Indonesia", type: "enterprise", category: "private" },
  { name: "GOTO (Gojek Tokopedia)", type: "enterprise", category: "private" },
  { name: "PrivyID", type: "enterprise", category: "private" },
  { name: "Moratelindo", type: "enterprise", category: "private" },
  { name: "Sinarmas", type: "enterprise", category: "private" },
  { name: "Bara Perkasa Investama", type: "enterprise", category: "private" },
  { name: "Cemindo Gemilang", type: "enterprise", category: "private" },
  { name: "Tridatu -", type: "enterprise", category: "private" }
];

export const statistics = [
  { number: "500+", label: "Proyek Selesai", icon: "CheckCircle2" },
  { number: "200+", label: "Klien Puas", icon: "Users" },
  { number: "50+", label: "Partner Teknologi", icon: "Handshake" },
  { number: "24/7", label: "Support", icon: "Clock" }
];

export const products = [
  {
    id: 1,
    slug: "skophi",
    name: "Skophi",
    category: "Smart City Platform",
    description: {
      id: "Platform untuk memantau dan menganalisis pemberitaan serta opini di media tentang pejabat dan instansi pemerintah secara real-time",
      en: "A platform to monitor and analyze news and opinions in the media about officials and government agencies in real-time."
    },
    image: "/images/products/skophi.png",
    features: [
      "Sistem Intelijen Narasi Media Real-Time",
      "Executive Insights dalam 60 Detik",
      "Analisis Kuantitatif Spektrum & Tekanan Aktor"
    ],
    detailFeatures: [
      {
        id: "Monitoring Media Real-time 24/7",
        en: "Real-time Media Monitoring 24/7"
      },
      {
        id: "Analisis Sentimen & Tren",
        en: "Sentiment & Trend Analysis"
      },
      {
        id: "Dashboard & Laporan Eksekutif",
        en: "Dashboard & Executive Reports"
      },
      {
        id: "Notifikasi & Deteksi Dini Krisis",
        en: "Notifications & Early Crisis Detection"
      }
    ],
    pdfUrl: "/pdf/skophi-product-brief.pdf"
  },
  {
    id: 2,
    slug: "desa-proaktif",
    name: "Desa Proaktif",
    category: "Rural Digitalization",
    description: "Solusi pemberdayaan desa melalui layanan digital, konektivitas, dan sistem manajemen komunitas terpadu",
    image: "/images/products/Desa%20Proaktif.png",
    features: [
      "Konektivitas desa & e-government services",
      "Platform partisipasi warga dan pelaporan cepat",
      "Solusi layanan kesehatan & pendidikan jarak jauh",
      "Manajemen sumber daya lokal berbasis data"
    ],
    pdfUrl: "/pdf/desa-proaktif-product-brief.pdf"
  },
  {
    id: 3,
    slug: "zi-care",
    name: "Zi.Care",
    category: "GeoSpatial & Mining",
    description: {
      id: "Platform digital kesehatan terintegrasi untuk membantu fasilitas kesehatan mengelola layanan dan data pasien secara efisien",
      en: "An integrated digital health platform to help healthcare facilities manage services and patient data efficiently."
    },
    image: "/images/products/zicare.png",
    features: [
      {
        id: "Rekam Medis Elektronik (RME)",
        en: "Electronic Medical Records (EMR)"
      },
      {
        id: "Manajemen Operasional Klinik & Rumah Sakit",
        en: "Clinic & Hospital Operational Management"
      },
      {
        id: "Integrasi Sistem & Data Kesehatan",
        en: "Health System & Data Integration"
      }
    ],
    pdfUrl: "/pdf/zi-care-product-brief.pdf"
  },
  // Green City removed per request
];
